import React, { useEffect } from 'react';
import styled from 'styled-components';
import { openInNewTabIcon } from '../../commonImage';
import { getAppURL, openLinkInSameTab } from '../../utils/commonUtils';
import { useDispatch, useSelector } from 'react-redux';
import { IStore } from '../../store';
import { IE_APPS } from '../../label.constant';
import { showMyJuniorModal } from '../../store/actions/commonActions';

interface CommonAppsContainerProps {
  item: { name: string; isFavourite: boolean; url?: string };
}

const CommonAppsContainer: React.FC<CommonAppsContainerProps> = ({ item }) => {
  const userMailID = useSelector((state: IStore) => state.common?.userEmail);
  const dispatch = useDispatch();
  useEffect(() => {
    item['url'] = getAppURL(item?.name);
  }, [item]);

  const nameMapping = {
    Embryonic:'Embryonic (Incl. Outside-In Web Data)',
    PEVC: 'Private Equity & Venture Capital',
    'Secondary Research': 'Outside-In Web Data',
    'Market reports': 'Market Reports',
  };

  const handleAppsRouting = (item: any) => {
    if (item.name === IE_APPS.MYJUNIOR) {
      dispatch(showMyJuniorModal(true));
    } else openLinkInSameTab(item, userMailID);
  };

  return (
    <ButtonContainer>
      <Button onClick={() => handleAppsRouting(item)}>
        <span
          className={'appName'}>
          {nameMapping[item?.name as keyof typeof nameMapping] || item?.name}{' '}
        </span>
        <LinkIcon className="link-icon">
          <a>
            <img src={openInNewTabIcon} alt={item?.url} />
          </a>
        </LinkIcon>
      </Button>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  margin-left: -5px;
`;

const Button = styled.button`
  cursor: pointer;
  background-color: #FFFFFF;
  min-height: 40px;
  width: 100%;
  display: flex;
  align-items: center; /* Vertically center items */
  justify-content: space-between;
  margin-top: 6px;
  gap: 8px;
  border-radius: 8px;
  padding: 8px;
  border: none;
  transition: background-color 0.2s;
  .appName {
    font-family: 'EYInterstate';
    font-weight: 300;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
    color: #000000;
    text-align: left;
    flex: 1 1 auto;
    word-break: break-word;
    white-space: normal;
    overflow-wrap: anywhere;
  }
  .link-icon {
    opacity: 0;
    transition: opacity 0.2s;
    display: flex;
    align-items: center;
  }
  &:hover {
    background-color: #F3F3F5;
    border-radius: 8px;
    .link-icon {
      opacity: 1;
    }
  }
`;

const LinkIcon = styled.div`
  display: flex;
  align-items: center; /* Vertically center icon */
  padding-left: 5px;
  min-width: 24px;
  a {
    cursor: pointer;
  }
`;
export default CommonAppsContainer;
